import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import { getbookingDetailsAsideUrl, GET_BOOKING_DETAILS_ASIDE, headers } from "../../../utils/constants"
import moment from 'moment';

export const get_aside_details_action = (userID, centerID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: userID,
            CenterID: centerID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getbookingDetailsAsideUrl, mapdata, headers);

        dispatch({
            type: GET_BOOKING_DETAILS_ASIDE,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};